import type { ComponentType, ReactNode } from "react";
import classNames from "classnames";
import I18n from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";

export interface CheckoutFormFieldWrapperProps {
  addon?: ReactNode;
  childClassName?: string;
  children: ReactNode;
  className?: string;
  ["data-testid"]?: string;
  LabelComponent?: ComponentType<{ weight?: string }>;
  name: string;
  optional?: boolean;
}

export const CheckoutFormFieldWrapper = ({
  name,
  addon,
  className,
  childClassName,
  children,
  optional,
  LabelComponent = Typography.LabelSm,
  ["data-testid"]: dataTestId,
}: CheckoutFormFieldWrapperProps) => (
  <div
    className={classNames(className, "flex flex-col")}
    data-testid={dataTestId}
  >
    <div
      className={classNames(childClassName, "mb-1 flex flex-row items-center")}
    >
      <div className="flex flex-row items-center gap-x-1">
        <LabelComponent weight="semibold">
          {I18n.t(`paywall_checkout.form.fields.${name}`)}
        </LabelComponent>
        {optional && (
          <>
            {" "}
            <Typography.LabelSm weight="normal" color="text-light">
              {`(${I18n.t("paywall_checkout.form.fields.optional")})`}
            </Typography.LabelSm>
          </>
        )}
      </div>
      {addon}
    </div>
    {children}
  </div>
);
